import React from 'react'
import {useIntl} from 'react-intl'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import {useAuth} from '../../../../../app/modules/auth'
import {PortalCustomerMenu} from './PortalCustomerMenu'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const {currentUser} = useAuth()

  return (
    <>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
            {intl.formatMessage({id: 'MENU.TITLE.DADHBOARD'})}
          </span>
        </div>
      </div>
      <SidebarMenuItem
        to='/dashboard'
        fontIcon='bi-grid-1x2'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
      />

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
            {intl.formatMessage({id: 'MENU.TITLE.MANAGEMENT'})}
          </span>
        </div>
      </div>

      {!!currentUser?.administrator || !!currentUser?.manager ? (
        <>
          <SidebarMenuItemWithSub
            to='#'
            title={intl.formatMessage({id: 'MENU.TEAMS_AND_USERS'})}
            fontIcon='bi-people'
          >
            <SidebarMenuItem
              to='/teams'
              title={intl.formatMessage({id: 'MENU.TEAMS'})}
              hasBullet={true}
            />
            <SidebarMenuItem
              to='/users'
              title={intl.formatMessage({id: 'MENU.USERS'})}
              hasBullet={true}
            />
          </SidebarMenuItemWithSub>
        </>
      ) : null}

      <SidebarMenuItem
        fontIcon='bi-bar-chart-line'
        to='/reports'
        title={intl.formatMessage({id: 'MENU.REPORTS'})}
      />

      <SidebarMenuItem
        fontIcon='bi-folder2'
        to='/projects'
        title={intl.formatMessage({id: 'MENU.PROJECTS'})}
      />
      <SidebarMenuItem
        fontIcon='bi-check2-square'
        to='/mytasks'
        title={intl.formatMessage({id: 'MENU.MYTASKS'})}
      />
      <SidebarMenuItem
        fontIcon='bi-list-task'
        to='/tarefas'
        title='Todas as tarefas'
      />
      <SidebarMenuItem
        fontIcon='bi-lightning-charge'
        to='/sprints'
        title={intl.formatMessage({id: 'MENU.SPRINTS'})}
      />

      <SidebarMenuItem
        fontIcon='bi-calendar3'
        to='/calendar'
        title={intl.formatMessage({id: 'MENU.CALENDAR'})}
      />
      {/* <SidebarMenuItem icon='/media/icons/duotune/communication/com011.svg' to='/tickets' title={intl.formatMessage({id: 'MENU.TICKETS'})} /> */}
      {currentUser?.administrator || currentUser?.manager ? (
        <>
          <SidebarMenuItem
            fontIcon='bi-calendar2-week'
            to='/schedules'
            title={intl.formatMessage({id: 'MENU.SCHEDULE'})}
          />
          <SidebarMenuItemWithSub
            to='#'
            title='Desempenho da Equipe'
            fontIcon='bi-graph-up-arrow'
          >
            <SidebarMenuItem
              to='/time-tracking'
              title={intl.formatMessage({id: 'MENU.TIME_TRACKING'})}
              hasBullet={true}
            />
            <SidebarMenuItem to='/desempenho-equipe' title='Desempenho' hasBullet={true} />
          </SidebarMenuItemWithSub>
        </>
      ) : (
        <>
          <SidebarMenuItem
            fontIcon='bi-stopwatch'
            to='/time-tracking-user'
            title={intl.formatMessage({id: 'MENU.TIME_TRACKING'})}
          />
          {!currentUser?.external_user ? (
            <SidebarMenuItem
              fontIcon='bi-graph-up-arrow'
              to='/meu-desempenho'
              title='Meu desempenho'
            />
          ) : null}
        </>
      )}

      {!currentUser?.external_user ? (
        <>
          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                {intl.formatMessage({id: 'MENU.TITLE.CMS'})}
              </span>
            </div>
          </div>

          {currentUser?.administrator || currentUser?.manager ? (
            <>
              <SidebarMenuItem
                fontIcon='bi-building'
                to='/clients'
                title={intl.formatMessage({id: 'MENU.CLIENTS'})}
              />
              <SidebarMenuItem
                fontIcon='bi-file-earmark-text'
                to='/contracts'
                title={intl.formatMessage({id: 'MENU.CONTRACTS'})}
              />
              {/* Orçamento de Projeto: oculto do menu por enquanto; acessível apenas pela URL /orcamento-projeto */}
              {/* <SidebarMenuItem
                icon='/media/icons/duotune/graphs/gra001.svg'
                to='/orcamento-projeto'
                title={intl.formatMessage({id: 'MENU.PROJECT_BUDGET'})}
              /> */}
            </>
          ) : null}

          <SidebarMenuItemWithSub
            to='#'
            title={intl.formatMessage({id: 'MENU.WIKI'})}
            fontIcon='bi-journal-text'
          >
            <SidebarMenuItem
              to='/wiki'
              title={intl.formatMessage({id: 'MENU.POST'})}
              hasBullet={true}
            />
            <SidebarMenuItem
              to='/wiki/wiki-config'
              title={intl.formatMessage({id: 'MENU.SKETCH'})}
              hasBullet={true}
            />
            <SidebarMenuItem
              to='/category'
              title={intl.formatMessage({id: 'MENU.CONFIG_CATEGORY'})}
              hasBullet={true}
            />
            <SidebarMenuItem
              to='/tags'
              title={intl.formatMessage({id: 'MENU.CONFIG_TAGS'})}
              hasBullet={true}
            />
          </SidebarMenuItemWithSub>
        </>
      ) : null}

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Suporte</span>
        </div>
      </div>
      {!!currentUser?.administrator || !!currentUser?.manager ? <PortalCustomerMenu /> : null}
      <SidebarMenuItem
        fontIcon='bi-question-circle'
        to='https://help.taskrush.com.br/'
        title='Base de Conhecimento'
        external
      />
    </>
  )
}

export {SidebarMenuMain}
